import http from 'conversations-http/clients/http';
export const getFilterRulesByThreadId = ({
  threadId
}) => http.get(`conversations-email/v1/filtering/filter-reasons/${threadId}`);